import { create } from "zustand"

interface IuseOsLiteStore {
  addAccounts: boolean
  setAddAccounts: (value: boolean) => void
  searchValue: string
  setSearchValue: (value: string) => void
  searchLoading: boolean
  setSearchLoading: (value: boolean) => void
  listSearch: string
  setListSearch: (value: string) => void
}

const useOsLiteStore = create<IuseOsLiteStore>((set) => ({
  addAccounts: false,
  setAddAccounts: (value) => set({ addAccounts: value }),
  searchValue: "",
  setSearchValue: (value) => set({ searchValue: value }),
  searchLoading: false,
  setSearchLoading: (value) => set({ searchLoading: value }),
  listSearch: "",
  setListSearch: (value) => set({ listSearch: value })
}))

export default useOsLiteStore
